// User related queries
export const GET_USER_QUERY = 'GET_USER_QUERY';

export const GET_AI_AGENTS_QUERY = 'GET_AI_AGENTS_QUERY';
export const GET_AI_AGENT_SUITES_QUERY = 'GET_AI_AGENT_SUITES_QUERY';
export const GET_AI_AGENT_CATEGORIES_QUERY = 'GET_AI_AGENT_CATEGORIES_QUERY';
export const CLAIM_AGENT_SUITE_QUERY = 'CLAIM_AGENT_SUITE_QUERY';

// Integrations Query Keys
export const GET_AVAILABLE_INTEGRATIONS_QUERY =
  'GET_AVAILABLE_INTEGRATIONS_QUERY';

export const BLOG_QUERY_KEYS = {
  all: ['public-blog'] as const,
  posts: ({
    variant,
    page,
    perPage,
    status,
    tag,
  }: {
    variant: string;
    page?: number;
    perPage?: number;
    status?: string;
    tag?: string;
  }) =>
    [
      ...BLOG_QUERY_KEYS.all,
      'posts',
      variant,
      page ?? 1,
      perPage ?? 10,
      status ?? '',
      tag ?? '',
    ] as const,
  tags: ({
    variant,
    page,
    perPage,
  }: {
    variant: string;
    page?: number;
    perPage?: number;
  }) =>
    [
      ...BLOG_QUERY_KEYS.all,
      'tags',
      variant,
      page ?? 1,
      perPage ?? 50,
    ] as const,
  detail: (variant: string, postId: number | string | undefined) =>
    [...BLOG_QUERY_KEYS.all, 'detail', variant, postId ?? ''] as const,
};

// Heartbeat Query Keys
export const HEARTBEAT_QUERY_KEYS = {
  all: ['heartbeats'] as const,
  list: () => [...HEARTBEAT_QUERY_KEYS.all, 'list'] as const,
  available: () => [...HEARTBEAT_QUERY_KEYS.all, 'available'] as const,
  agent: (agentKey: string) =>
    [...HEARTBEAT_QUERY_KEYS.all, 'agent', agentKey] as const,
};

export const HEARTBEAT_MUTATION_KEYS = {
  initialize: 'INITIALIZE_HEARTBEAT',
  pause: 'PAUSE_HEARTBEAT',
  deleteSchedule: 'DELETE_HEARTBEAT_SCHEDULE',
};
